import React from 'react';

import './styles.css';

import search from '../../assets/icons/search-red.png';

function SearchBar({ placeholder, value, setValue }) {
    return(
        <div className="search-bar-container">
            <img src={search} className="search-icon" alt="search" />
            <input
                className="search-bar-input"
                type='text'
                value={value}
                onChange={(e) => setValue(e.target.value)}
                placeholder={placeholder}
            />
        </div>
    )
}

export default SearchBar;